<script setup lang="ts">
import { computed, defineProps, defineEmits } from 'vue'
import FormRow from "@/components/Common/FormRow.vue"
const props = withDefaults(
  defineProps<{
    title: string
    modelValue: string | null
    error: string[]
    windowInnerWidth: number
    required: boolean
    readonly: boolean
    rowContentClass: string
  }>(),
  {
    required: false,
    readonly: false,
    rowContentClass: ''
  }
)

const emits = defineEmits(['update:modelValue'])

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})
</script>
<template>
  <FormRow
    :title="props.title"
    :windowInnerWidth="props.windowInnerWidth"
    :required="props.required"
    :rowContentClass="props.rowContentClass"
  >
    <v-text-field
      v-model="modelValue"
      :error-messages="props.error"
      maxlength="255"
      :readonly="readonly"
      :clearable="!readonly"
    />
  </FormRow>
</template>